import { Container} from 'react-bootstrap';
import "./HeroSectionComponent.css";
import heroImage from '../assets/TV-App-PoC.png';

const HeroSectionComponent = () => (
  <div className="home-page">
    <Container fluid className="section-container">
      <div className="mb-5">
        <h1 className="text-center impact-statement">
          Connect & Grow
        </h1>
      </div>
        <div className="hero-image-container">
          <div className="background-image"></div>
          <img src={heroImage} alt="Real Estate Impact" className="hero-image" />
          <div className="hero-overlay-text">
            Digital Signage | Unique Experiences
          </div>
        </div>
    </Container>
  </div>
);

export default HeroSectionComponent;
